/* template */
<template minapp="mpx" xlang="wxml"><div class="card-container"><mpx-view @tap.stop="clickItem" :class='("card-box "+(touchMoveActive))'><mpx-view @tap.stop="delItem" class="del"><slot name="delContext" v-if="(isShowDel)"></slot></mpx-view><mpx-view @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" class="card"><slot name="mainContext"></slot></mpx-view></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1fb7d810"}'>
  .card-container{
    flex:1;
    border-radius: 16rpx;
  }
  .card-box{
    display: flex;
    overflow: hidden;
    justify-content: flex-start;
    flex-direction:row-reverse;
  }
  .card{
    display:flex;
    justify-content: space-between;
    flex-direction:column;
    transform: translateX(264rpx)
    transition: all 0.4s;
    margin-left: -260rpx;
    width:100%;
  }
  .touch-move-active .card{
    transform: translateX(106rpx)
    transition: all 0.4s;
  }
  .del{
    color: #fff;
    overflow: hidden;
    width:260rpx;
    box-sizing: border-box;
    margin:2rpx;
  }
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1fb7d810"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex1fb7d810%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex1fb7d810%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1fb7d810"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index1fb7d810/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
